document.addEventListener("DOMContentLoaded", function(event) { 
  var productStickyNav = document.querySelector('#sticker.product-nav');
  var productStickyNavWrapper = document.querySelector('#sticker-sticky-wrapper');
  var productStickyNavTop = productStickyNavWrapper.getBoundingClientRect().top + window.pageYOffset;
  var productStickyNavHeight = productStickyNav.offsetHeight;
  
  if (productStickyNavTop <= window.pageYOffset) {
    productStickyNav.classList.add('is-sticky');
    productStickyNavWrapper.style.height = productStickyNavHeight + 'px';
  } else {
    productStickyNav.classList.remove('is-sticky');
    productStickyNavWrapper.style.height = '';
  }

  if (productStickyNav != null && productStickyNavWrapper != null) {
    window.addEventListener('scroll', function() {
      productStickyNavHeight = productStickyNav.offsetHeight;
      productStickyNavTop = productStickyNavWrapper.getBoundingClientRect().top + window.pageYOffset;
      if (productStickyNavTop <= window.pageYOffset) {
        productStickyNav.classList.add('is-sticky');
        productStickyNavWrapper.style.height = productStickyNavHeight + 'px';
      } else {
        productStickyNav.classList.remove('is-sticky');
        productStickyNavWrapper.style.height = '';
      }
    });
  }
  
  var productStickyNavMobileArrow = document.querySelector('#sticker.product-nav .mobile_arrow');
  var productStickyNavMobileMenu = document.querySelector('#sticker.product-nav .right_column');
  
  if (productStickyNavMobileArrow != null && productStickyNavMobileMenu != null) {
    productStickyNavMobileArrow.addEventListener("click", function() {
      this.classList.toggle("active");
      if (productStickyNavMobileMenu.style.maxHeight) {
        productStickyNavMobileMenu.style.maxHeight = null;
      } else {
        productStickyNavMobileMenu.style.maxHeight = productStickyNavMobileMenu.scrollHeight + "px";
      }
    });
  }

  var nav_anchorLink = document.querySelector('.nav-anchor-link');
  if(nav_anchorLink) {
    document.addEventListener('click', function(e){
      var el = e.target;

      if(el.classList.contains('nav-anchor-link') || el.closest('.nav-anchor-link')) {
        if(!el.classList.contains('nav-anchor-link')) {
          el = el.closest('.nav-anchor-link');
        }
        e.preventDefault();

        var isSpecialLink = el.classList.contains('special-nav-anchor-link');
        if(isSpecialLink) {
          var parentSection = el.closest('.shopify-section');
          var nextSection = parentSection.nextElementSibling;
          var href = '#'+nextSection.getAttribute('id');
    
          
        } else {
          var href = el.getAttribute('href');
        }
        var scrollTarget = document.querySelector(href);
       
        if(scrollTarget) {
          var topOffset = document.querySelector('.product-nav').offsetHeight;
          var elementPosition = scrollTarget.getBoundingClientRect().top;
          var offsetPosition = elementPosition - topOffset;

          window.scrollBy({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }

      }
    });
  }
});